<h2>Mobile Home Sections <button class="icon--add btn--default" (click)="linkSection()">Link Mobile Home</button></h2>
<table class="mvd_table--primeng">
    <thead>
        <tr>
            <th>VIN</th>
            <th class="w--icon">Delete</th>
        </tr>
    </thead>
    <tbody *ngIf="linkedSections?.length">
        <tr *ngFor="let linkedSection of linkedSections">
            <td><a class="icon--select" href="javascript:void(0)" title="Open Vehicle Information" (click)="viewVehicle(linkedSection.vehicleId)">{{linkedSection.vin}}</a></td>
            <td class="text-center">
                <a class="icon--delete" href="javascript:void(0)" title="Remove Link" (click)="delete(linkedSection.vehicleId)"></a>
            </td>
        </tr>
    </tbody>
    <tbody *ngIf="linkedSections?.length == 0">
        <tr>
            <td colspan="2">No Information Available</td>
        </tr>
    </tbody>
</table>

<table class="mvd_table--primeng">
    <tr>
        <th>
            Domicile Address
            <a *ngIf="!domicileAddress" class="icon--add" title="Add Domicile" href="javascript:void(0)" data-bs-toggle="tooltip" (click)="addDomicile()"></a>
            <a *ngIf="domicileAddress && !isAddressMasked" class="icon--edit" title="Edit Domicile" href="javascript:void(0)" data-bs-toggle="tooltip" (click)="editDomicile()"></a>
            <a *ngIf="domicileAddress" class="icon--delete" title="Delete Domicile" href="javascript:void(0)" data-bs-toggle="tooltip" (click)="deleteDomicile()"></a>
        </th>
    </tr>
        <tr>
            <td>
                <ng-container *ngIf="domicileAddress">{{domicileAddress.addressLine1}} {{domicileAddress.addressLine2 ? domicileAddress.addressLine2 : ''}}, {{domicileAddress.city}}, {{domicileAddress.jurisdictionId | displayValue:jurisdictions}} {{domicileAddress.postalZipCode}}, {{domicileAddress.countyId | displayValue:counties}}</ng-container>
                <ng-container *ngIf="!domicileAddress">No Information Available</ng-container>
            </td>
        </tr>
</table>